"use client";

import { isSchoolPath, schoolHref } from "@/lib/school-routes";
import { useRouter as useNextRouter, usePathname } from "next/navigation";
import { useMemo } from "react";

export function useRouter() {
  const router = useNextRouter();
  const pathname = usePathname();
  return useMemo(
    () =>
      !isSchoolPath(pathname)
        ? router
        : {
            ...router,
            push: (href: string, options?: Parameters<typeof router.push>[1]) =>
              router.push(schoolHref(href, pathname), options),
            replace: (href: string, options?: Parameters<typeof router.replace>[1]) =>
              router.replace(schoolHref(href, pathname), options),
            prefetch: (href: string, options?: Parameters<typeof router.prefetch>[1]) =>
              router.prefetch(schoolHref(href, pathname), options),
          },
    [router, pathname]
  );
}
